<div class="modal-header">
  <h5 class="modal-title" i18n>Sync Data to Subunits</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <mat-table matSort [dataSource]="dataSource">
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef><ng-container i18n>Name</ng-container></mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.nickname || element.name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
      <mat-header-cell *matHeaderCellDef> <ng-container i18n>Description</ng-container></mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span class="" matTooltip="Beds">
          <i class="fas fa-bed-front text-info"></i>
          {{ element.bedrooms || 0 }}
        </span>
        <span class="ml-3" matTooltip="Baths">
          <i class="fas fa-bath text-indigo"></i>
          {{ element.bathrooms || 0 }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="phone">
      <mat-header-cell *matHeaderCellDef> <ng-container i18n>Phone</ng-container></mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span [matTooltip]="element.phone" class="text-truncate"> {{ element.phone }}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  <mat-paginator2
    #paginator
    [pageSize]="10"
    [length]="dataSource?.data?.length"
    [class.hidden]="isEmptyTable$ | async"
    [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
    [showFirstLastButtons]="true"
  >
  </mat-paginator2>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="onSave()" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
